import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';

import { ContratoService } from '../../../../../providers/contrato-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModalProdutoContratoPage } from '../../../../modais/modal-produto-contrato/modal-produto-contrato';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

import { ModalArquivosPage } from '../../../../modais/modal-arquivos/modal-arquivos';

@Component({
  selector: 'page-acrescimo-supressoes-contratos-versus-limite-legal',
  templateUrl: 'acrescimo-supressoes-contratos-versus-limite-legal.html',
  providers: [
    ContratoService
  ]
})
export class AcrescimosOuSupressoesContratosVersusLimiteLegalPage extends ModulosController {
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "52";
  limiteDiferencaLimiteLegal: any = 25.00;
  listaDados: any;
  pageAcresDec: number = 1;

  idModuloPca: any;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.idModuloPca = this.navParams.get('analise').idModuloPca;

    this.carregarDados();

    this.setModuloId(5);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  carregarDados() {
    this.contratoService.obterDadosAcrescimosOuSupressoes().subscribe(data => {
      this.listaDados = data;
      if (this.listaDados.analises.length > 0) {
        this.listaDados.analises.forEach(analise => {
          this.calcularDiferencaAcrescimos(analise);
          this.calcularDiferencaSupressoes(analise);
          this.somarValorDasSupressoes(analise.contrato);
          this.somarValorDosAcrescimos(analise.contrato);
        });
      }
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  obterProdutosDoAditivo(idAditivo) {
    this.contratoService.listarProdutosAditivo(idAditivo).subscribe(data => {
      if (data != null) {

        data.forEach(produto => {
          produto.valor = this.formatarValorNumerico(produto.valor);
        });

        return data;
      }
    }, error => {
      console.log("erro: " + error);
      return null;
    });
  }

  formatarPorcentagem(valor) {
    let valorString = valor.toString();

    if (valorString.indexOf('.') != -1) {
      let tamanhoAntesDaVirgulas = valorString.indexOf('.') + 1;
      let numeroDeCasasDecimais = 2;
      valorString = valorString.substr(0, tamanhoAntesDaVirgulas + numeroDeCasasDecimais);
    }

    return valorString.replace('.', ',') + "%";
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  formatarZeroEsquerda(valor) {
    return valor.replace(/^0+(?!\.|$)/, '');
  }

  voltar() {
    this.menuService.redirecionarPagina(this.contratoService.obterIdPaginaContrato());
  }

  salvarComentario(enviarMensagem = true) {
    this.loading = true;
    if (this.listaDados) {

      this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);

      this.contratoService.salvarDadosAcrescimosOuSupressoes(this.listaDados, this.idSecaoPagina).subscribe(data => {

        if (enviarMensagem) {
          this.alertService.mostraAlerta("", "Salvo com sucesso.");
        }

        this.loading = false;

      }, error => {
        if (enviarMensagem) {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        }
        this.loading = false;
      });
    }
  }

  submeterNoCertificado() {
    this.loading = true;
    if (this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null || this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.listaDados) {

        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);

        this.contratoService.finalizarForaDoLimiteAnalista(this.listaDados, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }
  }

  // abrirTermoReferencia(contrato) {
  //   let titulo = "Termo(s) de Referência(s)";

  //   let modal = this.modalCtrl.create(ModalTermoReferenciaAditivoPage,
  //     {
  //       titulo: titulo,
  //       contrato: contrato,
  //       isJurisdicionado: false
  //     });
  //   modal.onDidDismiss(retornoModal => {
  //     if (retornoModal && retornoModal.flag) {
  //     }
  //   });

  //   modal.present();
  // }

  abrirTermoReferencia(item) {
    let titulo = "Documentos";

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: item.nmContrato,
        idModuloPCA: this.idModuloPca,
        tipoAnalise: '49',
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        origemArquivo: "Contrato: " + item.nmContrato,
        origemFilter: 'CONTRATO',
        tipoEntidadeExercicio: 0,
        tipodocumento: 0
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
      }
    });

    modal.present();
  }

  somarValorDosAcrescimos(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      total += aditivo.totalAcrescimo
    });

    return this.formatarValorNumerico(total);
  }

  somarValorDasSupressoes(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      total += aditivo.totalSupressao
    });

    return this.formatarValorNumerico(total);
  }

  calcularDiferencaAcrescimos(analise) {
    let total: any = 0;

    analise.contrato.aditivos.forEach(aditivo => {
      total += aditivo.totalAcrescimo
    });

    let porcentagemAcrescimoSobreContrato = (total / analise.valorAtualizadoCalculado) * 100;
    let diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato - this.limiteDiferencaLimiteLegal;

    let retorno = "";

    if (diferencaLimiteAcrescimo <= 0) {
      retorno = "-";
    } else {
      retorno = this.formatarPorcentagem(diferencaLimiteAcrescimo)
    }
    return retorno;
  }

  calcularDiferencaSupressoes(analise) {
    let total: any = 0;

    analise.contrato.aditivos.forEach(aditivo => {
      total += aditivo.totalSupressao;
    });

    let porcentagemAcrescimoSobreContrato = (total / analise.valorAtualizadoCalculado) * 100;
    let diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato - this.limiteDiferencaLimiteLegal;

    let retorno = "";

    if (diferencaLimiteAcrescimo <= 0) {
      retorno = "-";
    } else {
      retorno = this.formatarPorcentagem(diferencaLimiteAcrescimo);
    }

    return retorno;
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 10;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  visualizarProdutos(aditivo) {
    let titulo = "Produtos do Aditivo " + aditivo.nmAditivo;

    let modal = this.modalCtrl.create(ModalProdutoContratoPage,
      {
        param1: titulo,
        aditivo: aditivo,
        jurisdicionado: false,
        idModuloPca: this.idModuloPca
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.carregarDados();
      }
    });

    modal.present();
  }

  capitalize(str) {
    let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos/contrato-analise/acrescimo-supressoes-contratos-versus-limite-legal/acrescimo-supressoes-contratos-versus-limite-legal.ts